require("dotenv").config();

export default Object.freeze({
    apiUri: process.env.REACT_APP_API_URI,
    sentryDsn: process.env.REACT_APP_SENTRY_DSN_URI,
});
